import React, { useEffect, useState } from 'react';
import { EmptyState } from '@/components/custom/empty-state';
import { Link } from 'react-router-dom';
import { StudyGuideQuizModal } from './study-guide-quiz-modal';
import { StudyGuideQuizDataGrid } from './study-guide-quiz-data-grid';
import { useClient } from 'jsonapi-react';
import { GuideAboutCard, GuideAboutCardBody, GuideAboutCardFooter, GuideAboutCardHeader, GuideAboutCardTitle } from '@/components/custom/guide';
import { Button } from '@/components/ui/button';
import { Dialog, DialogTrigger } from '@/components/ui/dialog';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import { PlayfulCard } from '@/components/custom/playful-card';

export function StudyGuideQuiz() {
  const [quizData, setQuizData] = useState([]);
  const playful = usePlayfulStudent();

  const client = useClient();

  const getQuizData = async () => {
    const response = await client.fetch('study_plan_reports/quiz_performance');
    return response.data;
  };

  useEffect(() => {
    getQuizData().then(data => {
      if (data.quiz_performance) setQuizData(data.quiz_performance);
    });
  }, []);

  const hasQuizData = quizData.length > 0;

  if (playful) {
    return (
      <PlayfulCard
        className="flex h-full flex-col gap-3 p-4"
        style={{ background: '#fff' }}
      >
        <p
          className="mb-0 text-sm font-extrabold"
          style={{ color: '#222731' }}
        >
          Rendimento nos quizzes das aulas
        </p>

        {!hasQuizData && (
          <EmptyState
            type="data"
            title="Você ainda não respondeu nenhum quiz"
            text={
              <span>
                Assista uma <Link to="/curso">aula</Link> para responder um quiz
              </span>
            }
            variant="plain"
            className="m-auto"
          />
        )}

        {hasQuizData && (
          <>
            <StudyGuideQuizDataGrid data={quizData.slice(0, 6)} />

            <Dialog>
              <DialogTrigger asChild>
                <button
                  type="button"
                  className="self-start text-sm font-bold"
                  style={{ color: 'var(--color-secondary)' }}
                >
                  Ver mais
                </button>
              </DialogTrigger>

              <StudyGuideQuizModal data={quizData} />
            </Dialog>
          </>
        )}
      </PlayfulCard>
    );
  }

  return (
    <GuideAboutCard>
      <GuideAboutCardHeader>
        <GuideAboutCardTitle>Rendimento nos quizzes das aulas</GuideAboutCardTitle>
      </GuideAboutCardHeader>

      {!hasQuizData && (
        <GuideAboutCardBody isEmpty>
          <EmptyState
            type="data"
            title="Você ainda não respondeu nenhum quiz"
            text={
              <span>
                Assista uma <Link to="/curso">aula</Link> para responder um quiz
              </span>
            }
            variant="plain"
            className="m-auto"
          />
        </GuideAboutCardBody>
      )}

      {hasQuizData && (
        <>
          <GuideAboutCardBody>
            <StudyGuideQuizDataGrid data={quizData.slice(0, 6)} />
          </GuideAboutCardBody>

          <GuideAboutCardFooter>
            <Dialog>
              <DialogTrigger asChild>
                <Button variant="link">Ver mais</Button>
              </DialogTrigger>

              <StudyGuideQuizModal data={quizData} />
            </Dialog>
          </GuideAboutCardFooter>
        </>
      )}
    </GuideAboutCard>
  );
}
